<template>
    <div class="fill" style="min-width: 350px">
        <div class="row text-center mt-2 mr-2 header-tag p-0">
            <div class="col-3">时间</div>
            <div class="col">工位</div>
            <div class="col">项目</div>
            <div class="col">提出人</div>
            <div class="col">状态</div>
        </div>
        <PullToRefresh ref="scroll" style="top:2.5rem" :on-refresh="onRefresh" :on-infinite="onInfinite">
            <el-collapse class="fill-w" v-model="activeName" accordion @change="handleChange">
                <el-collapse-item v-for="(item,index) in taskData" :key="index" :name="item.id">
                    <div class="row text-center" slot="title" style="width: 100%">
                        <div class="col-3 m-auto">
                            <div class="row fill-w">
                                <p class="badge badge-light m-auto collapse-title">
                                    {{ item.startDate }} {{ item.startHHmm }}
                                </p>
                            </div>
                        </div>
                        <div class="col-3 collapse-title">{{ item.locationName }}</div>
                        <div class="col-2 collapse-title">{{ item.projectCode }}</div>
                        <div class="col-2 collapse-title">{{ item.createdByName }}</div>
                        <div class="col-2">
                            <p class="badge badge-pill m-auto" :class="tagClass[item.status-1]">
                                {{ statusName[item.status - 1] }}
                            </p>
                        </div>
                    </div>

                    <div>
                        <div class="row ml-2">
                            <div class="col-5 d-flex flex-column">
                                <div>安灯类型：{{ item.typeName }}</div>
                                <div>是否停机：{{ item.stopWork }}</div>
                                <div>项目编号：{{ hasCode(item.projectCode) ? item.projectCode : '无' }}</div>
                                <div v-if="hasCode(item.locationName)">工位：{{ item.locationName }}</div>
                                <div v-if="hasCode(item.operationName)">工序：{{ item.operationName }}</div>
                                <div>问题描述：{{ hasCode(item.description) ? '' : '无' }}</div>
                                <div class="text-break" v-if="hasCode(item.description)">{{ item.description }}</div>
                            </div>
                            <div class="col-7 d-flex flex-column">
                                <div>提交人：{{ item.createdByName }}</div>
                                <div>发起时间：{{ item.startTime }}</div>
                                <div v-if="hasCode(item.responseTime)">响应时间：{{ item.responseTime }}</div>
                                <div v-if="hasCode(item.finishTime)">完成时间：{{ item.finishTime }}</div>
                                <div v-if="hasCode(item.handleUserName)">处理人：{{ item.handleUserName }}</div>
                                <div class="mt-auto mr-3 d-flex flex-row-reverse"
                                     v-if="item.status===1 || item.status===3">
                                    <button type="button" class="mb-2 btn button-temp" style="width: 40%"
                                            @click="dialogVisible=true">响应
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </PullToRefresh>


        <el-dialog
            title="响应确认"
            :visible.sync="dialogVisible"
            append-to-body
            @closed="dialogClosed"
            width="80%">
      <span>您将响应由 {{ currentTask.createdByName }} 于 {{ currentTask.startTime }} 提出的安灯任务：{{
              currentTask.typeName
          }}</span>
            <el-input
                ref="handleInput"
                v-show="handleInputVisible"
                class="mt-1"
                type="textarea"
                :min="3"
                :autosize="{ minRows: 3, maxRows: 6 }"
                placeholder="处理描述"
                v-model="handleDescription">
            </el-input>
            <span slot="footer" class="dialog-footer">
        <div class="d-flex flex-row">
        <button type="button" class="btn btn-light ml-auto" @click="handleInputAppear">处理描述</button>
        <button type="button" class="btn btn-light ml-1" @click="dialogVisible = false">取 消</button>
        <button type="button" class="btn button-temp ml-1" @click="respondTask">确 定</button>
        </div>
      </span>
        </el-dialog>
    </div>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";
import PullToRefresh from "./PullToRefresh";
import {getDate, getTimeOfDay} from "./TimeUtil";

export default {
    name: "AndonRespondList",
    components: {PullToRefresh},
    mixins: [EmCommonApi],
    data() {
        return {
            activeName: '',
            code: '',
            taskData: [],
            currentTask: {},
            statusName: ['未响应', '已响应', '已超时', '已完成', '已撤销'],
            tagClass: ['badge-warning', 'badge-primary', 'badge-danger', 'badge-success', 'badge-secondary'],
            dialogVisible: false,
            done: function () {
            },
            currentPage: 1,
            baseUrl: process.env.VUE_APP_SITHMES_OUTSIDE,
            handleDescription: null,
            handleInputVisible: false
        }
    },
    created() {
        this.setVisible(false);
    },
    mounted() {
        this.onInfinite()
        this.activeName = Number.parseInt(this.$route.query.taskId + '');
        // this.activeName = JSON.parse(localStorage['url_return_json']).state;
    },
    beforeDestroy() {
        this.setVisible(true);
    },
    methods: {
        setVisible(visibility) {
            this.$store.commit("base/setShowHeader", visibility, {root: true});
            this.$store.commit("base/setShowSidebar", visibility, {root: true});
        },
        onRefresh: function (done) {
            this.done = done;
            //   3. 在刷新方法内部进行自己的逻辑处理 此处调用了后台接口
            this.getListData(true);
        },
        onInfinite: function (done) {
            this.done = done;
            this.getListData(false);
        },
        getListData(isFresh) {
            let _this = this;
            let _api = this.baseUrl + '/sithMesAndonTask/queryUser';
            this.$_emApiMixin_post(_api, {
                numRegPag: isFresh ? this.currentPage * 20 : 20,
                currentPage: isFresh ? 0 : this.currentPage
            }).then(value => {
                console.log(value);
                let taskList = [];
                for (let item of value.data) {
                    let task = {
                        id: item.id,
                        createdBy: item.createdBy,
                        createdByName: item.createdByName,
                        handleUserId: item.handleUserId,
                        handleUserName: item.handleUserIdName,
                        locationId: item.mstLocationId,
                        locationName: item.mstLocationName,
                        operationId: item.prdPpOperationId,
                        operationName: item.prdPpOperationName,
                        typeId: item.problemAndonTypeId,
                        typeName: item.problemAndonTypeName,
                        description: item.problemDescription,
                        startTime: item.startTime,
                        startDate: getDate(item.startTime),
                        startHHmm: getTimeOfDay(item.startTime),
                        responseTime: item.responseTime,
                        finishTime: item.finishTime,
                        status: item.status,
                        stopWork: item.stopWork ? '已停机' : '生产中',
                        projectCode: item.projectCode
                    }
                    taskList.push(task);
                }
                if (taskList.length > 0) {
                    if (isFresh) {
                        _this.taskData = taskList;
                    } else {
                        for (let temp of taskList) {
                            _this.taskData.push(temp);
                        }
                        _this.currentPage += 1;
                    }
                } else {
                    _this.$refs.scroll.loadComplete(true);
                }
                _this.handleChange(_this.activeName);
                console.log(_this.activeName)
                _this.done()
            })
        },
        hasCode(val) {
            return val !== undefined && val !== null && val !== '';
        },
        handleChange(taskId) {
            for (let task of this.taskData) {
                if (task.id === taskId) {
                    this.currentTask = task;
                    break
                }
            }
        },
        respondTask() {
            let _this = this;
            let _api = this.baseUrl + '/sithMesAndonTask/selective';
            this.$_emApiMixin_put(_api, {
                id: this.currentTask.id,
                responseTime: this.$_emApiMixin_dateFormat(new Date()),
                handleDescription: this.handleDescription,
                status: 2
            }).then(() => {
                _this.$message({
                    message: '响应成功',
                    type: 'success'
                })
                _this.onRefresh()
            })
            this.dialogVisible = false;
        },
        dialogClosed() {
            this.handleDescription = null;
            this.handleInputVisible = false;
        },
        handleInputAppear() {
            this.handleInputVisible = true;
            setTimeout(() => {
                this.$refs.handleInput.focus();
            }, 100);
        }
    }
}
</script>

<style scoped>
.header-tag {
    position: fixed;
    height: 2rem;
    width: 100%;
    font-size: 1rem;
    font-weight: bold;
}

.collapse-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.button-temp {
    color: #fff;
    background-color: rgb(23, 162, 184);
    border-color: rgb(156, 215, 225);
}

.button-temp:active {
    background-color: rgb(19, 132, 150);
    border-color: rgb(156, 215, 225);
    box-shadow: 0 0 0 0.2rem rgba(156, 215, 225, .6);
}

.button-temp:focus {
    color: #fff;
}

.fill {
    width: 100%;
    height: 100%;
}

.fill >>> .el-collapse-item__content {
    padding-bottom: 0;
}

.fill-w {
    width: 100%;
}

.fill-h {
    height: 100%;
}

</style>
